import { StyleProps } from "@shared/primitive-components"

export const buttonsWrap = (props: StyleProps) => ({
  marginTop: props.theme.spacing(2),
})

export const button = (props: StyleProps) => ({
  "&:not(:first-child)": {
    marginRight: props.theme.spacing(4),
  },
})
